module.exports = {
  helpers: {
    environments: require('./src/helpers/environments'),
    queryCollectionFormatter: require('./src/helpers/queryCollectionFormatter'),
    proxyRoutes: require('./src/helpers/proxyRoutes'),
  },
  constants: require('./src/constants'),
  models: require('./src/models'),
}
